import { Dialog } from "@headlessui/react";

import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import Button from "@/components/buttons/Button";

type TimeCodeModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm?: () => void;
};

const TimeCodeModal = ({ open, onClose, onConfirm }: TimeCodeModalProps) => {
  useEffect(() => {
    const blockKeys = (e: KeyboardEvent) => {
      const keys = [" ", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"];
      if (keys.includes(e.key)) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    if (open) {
      window.addEventListener("keydown", blockKeys, true);
      document.addEventListener("keydown", blockKeys, true);
    }

    return () => {
      window.removeEventListener("keydown", blockKeys, true);
      document.removeEventListener("keydown", blockKeys, true);
    };
  }, [open]);

  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} className="relative z-[100]">
      <div className="fixed inset-0 bg-[#0c0d12cc]" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4 ">
        <Dialog.Panel className=" mx-auto w-full max-w-[400px] rounded-[24px] bg-surface p-8 shadow-[0px_0px_2.875rem_#ff570830] max-md:rounded-xl max-md:p-6">
          <p className="text-center text-[24px] font-semibold max-md:text-[18px]">{t("player.does-continue")}</p>
          <div className="mt-6 grid grid-cols-2 gap-6 max-md:gap-4">
            <Button color="orange" size="medium" onClick={onConfirm}>
              {t("Actions.continue")}
            </Button>
            <Button color="black" size="medium" onClick={onClose}>
              {t("player.again")}
            </Button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default TimeCodeModal;
